import React from 'react'

import { CurrencyInput } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'
import { getCountryNameByCode } from '@fourthwall/utils/dist/inputs'

import type { FormValues } from '../../Shipping.types'
import { FixedRatesTable } from '../FixedRatesTable/FixedRatesTable'
import * as S from './FixedShipping.styled'

export const FixedShipping = () => {
  const formik = useFormikContext<FormValues>()

  const domesticCountryCode = formik.values.shippingLocation?.country || 'US'
  const domesticRatesSubtitle = getCountryNameByCode(domesticCountryCode) || 'United States'

  return (
    <>
      <S.Description>
        Charge a fixed price for shipping based on the number of items in the cart.
      </S.Description>

      <FixedRatesTable>
        <FixedRatesTable.Column
          title="Domestic rates"
          subtitle={domesticRatesSubtitle}
          inputs={[
            <CurrencyInput label="First item" {...formik.getFieldProps('domesticFirst')} />,
            <CurrencyInput
              label="Each additional item"
              {...formik.getFieldProps('domesticAdditional')}
            />,
          ]}
        />
        <FixedRatesTable.Column
          title="International rates"
          subtitle="Rest of the world"
          inputs={[
            <CurrencyInput label="First item" {...formik.getFieldProps('internationalFirst')} />,
            <CurrencyInput
              label="Each additional item"
              {...formik.getFieldProps('internationalAdditional')}
            />,
          ]}
        />
      </FixedRatesTable>
    </>
  )
}
